import { BuildInAppToolId, IAppToolConfig } from '../types/appTools';

export const buildInAppTools: IAppToolConfig[] = [
    {
        id: BuildInAppToolId.Messages,
        type: BuildInAppToolId.Messages,
        title: 'Messages',
        isVisible: () => true,
    },
    {
        id: BuildInAppToolId.SessionChats,
        type: BuildInAppToolId.SessionChats,
        title: 'Session Chats',
        isVisible: () => true,
        needSession: true,
    },
    {
        id: BuildInAppToolId.Meetings,
        type: BuildInAppToolId.Meetings,
        title: 'Meetings',
        isVisible: () => true,
    },
    {
        id: BuildInAppToolId.SupportChat,
        type: BuildInAppToolId.SupportChat,
        title: 'Support',
        isVisible: () => true,
    },
];

const useAppTools = inSession => {
    return buildInAppTools.filter(item => !item.needSession || item.needSession === inSession);
};

export default useAppTools;
